import { FC } from "react";
import clsx from "clsx";

interface IProps {
    IconSvg?: any;
    text: string;
    additionalClass?: string;
    onClick?: () => void;
}
const DropdownMessageControlItem: FC<IProps> = ({
    IconSvg,
    text,
    additionalClass,
    onClick,
}) => {
    return (
        <button
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onClick}
            className={clsx(
                "px-3 py-[0.625rem] text-gray-700 text-base",
                "bg-white",
                "flex items-center w-full",
                additionalClass
            )}
        >
            {IconSvg && <IconSvg className=" mr-2" width={16} height={16} />}{" "}
            {text}
        </button>
    );
};

export default DropdownMessageControlItem;
